<div class="wrapper">
  <div class="top-bar">
    <div class="content">
      <span (click)="goBack()">
        <img class="h-18" src="assets/images/icon/chevronleft.svg" />
        {{ translations['back_label'] }}
      </span>

      <span class="verticle-line"></span>

      <span (click)="navigateToLandingPage()">
        <img src="assets/images/icon/refresh.svg" />
        {{ translations['restart'] }}
      </span>
    </div>
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>

  <div class="main pt-1">
    <div class="overflow-scroll p-2 header">
      <div class="progress-container">
        <div class="progress-bar">
          <div
            *ngFor="let item of issueListEuht"
            class="progress-fill"
            [style.width.%]="progress"
            [ngClass]="{ inactive: !item.answered }"
          ></div>
        </div>
        <div class="progress-segment">{{ progress | number: '1.0-0' }}%</div>
      </div>
      <h2 class="header-text">{{ translations['check_machine'] }}</h2>

      <div *ngFor="let item of issueListEuht; let i = index">
        <div class="check-item">
          <div class="result-content">
            <div class="sub-content">
              <div
                class="status-indicator"
                *ngIf="!item.answered; else answeredTemplate"
              >
                <div class="circle"></div>
              </div>
              <ng-template #answeredTemplate>
                <div class="ticks"><i class="fas fa-check"></i></div>
              </ng-template>
              <div class="content-list">
                {{ item.translatedTitle }}
              </div>
            </div>

            <!-- Accordion icon -->
            <div
              *ngIf="item.translatedDetails !== '' || item.images.length > 0"
              class="accordion-icon"
              (click)="toggleAccordion(i)"
            >
              <i
                [ngClass]="
                  item.expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                "
              ></i>
            </div>
          </div>

          <div class="accordion-content" *ngIf="item.expanded">
            <p *ngIf="item.translatedDetails !== ''">
              {{ item.translatedDetails }}
            </p>

            <!-- Display multiple images if available -->
            <div
              class="img-list"
              *ngIf="!item?.isImagePopup && item.images.length > 0"
            >
              <div class="p-1">
                <img
                  [src]="item.images[0]"
                  class="img-thumbnail"
                  (click)="openPopup(item)"
                />
              </div>
            </div>

            <div class="img-list" *ngIf="item?.isImagePopup">
              <div class="p-1">
                <img
                  [src]="item.images[0]"
                  class="img-thumbnail"
                  (click)="openImagePopup(item.images, item)"
                />
              </div>
            </div>
            <!-- Display video if available -->
            <div *ngIf="item.video">
              <video controls>
                <source [src]="item.video" type="video/mp4" />
                {{ translations['video_tag'] }}
              </video>
            </div>
          </div>

          <div class="actions">
            <button
              class="ok-btn"
              [class.selectedOk]="item.status === 'ok'"
              [class.inactive]="item.status === 'issue'"
              (click)="answer(i, 'ok'); item.expanded = false"
            >
              <div *ngIf="item.status === 'ok'" class="tick">
                <i class="fas fa-check"></i>
              </div>
              <div>{{ translations['ok'] }}</div>
            </button>

            <button
              class="issue-btn"
              [class.selectedIssue]="item.status === 'issue'"
              [class.inactive]="item.status === 'ok'"
              (click)="answer(i, 'issue'); item.expanded = false"
            >
              <div *ngIf="item.status === 'issue'" class="tick-issue">
                <i class="fas fa-check"></i>
              </div>
              <div>{{ translations['issue'] }}</div>
            </button>
          </div>
        </div>
      </div>
      <div class="button-group">
        <button class="help-btn" (click)="resolved()">
          {{ translations['resolved'] }}
        </button>
        <button class="btn-blue-outline ms-1" (click)="needHelp()">
          <img class="chatIcon" src="assets/images/icon/chat.png" />
          <span> {{ translations['need_help'] }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Popup Container -->
  <div class="popup" *ngIf="showImagePopup">
    <div class="image-container">
      <div class="popup-container">
        <div class="do-container">
          <div class="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="black"
              viewBox="0 0 24 24"
            >
              <path
                d="M20.285 6.709a1 1 0 00-1.414 0L9 16.58l-4.871-4.87a1 1 0 00-1.414 1.415l5.577 5.576a1 1 0 001.414 0l10.283-10.283a1 1 0 000-1.414z"
              />
            </svg>
            <span>{{ translations['do'] }}</span>
          </div>
          <div class="flex">
            <div class="close-icon" (click)="closePopup()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="white"
                viewBox="0 0 24 24"
              >
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="img-overlay">
          <img
            *ngFor="let popupImg of popupImages; let idx = index"
            [src]="popupImg"
            class="img-section"
            alt="Poor results"
          />
          <div *ngIf="isLimescale" class="img-overlay-text">
            {{ translations['remove_lime'] }}
          </div>
        </div>
        <div class="dont-container">
          <div class="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="black"
            >
              <path
                d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 105.7 7.11L10.59 12l-4.89 4.89a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.89a1 1 0 000-1.4z"
              />
            </svg>
            <span>{{ translations['do_not'] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Image container-->
  <div class="popup" *ngIf="showPopup">
    <div class="image-container">
      <div class="popup-container">
        <div class="do-container">
          <div class="flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="black"
              viewBox="0 0 24 24"
            >
              <path
                d="M20.285 6.709a1 1 0 00-1.414 0L9 16.58l-4.871-4.87a1 1 0 00-1.414 1.415l5.577 5.576a1 1 0 001.414 0l10.283-10.283a1 1 0 000-1.414z"
              />
            </svg>
            <span>{{ translations['do'] }}</span>
          </div>
          <div class="flex">
            <div class="close-icon" (click)="closePopup()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="white"
                viewBox="0 0 24 24"
              >
                <path
                  d="M6 6L18 18M6 18L18 6"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="img-overlay">
          <img
            [src]="img"
            *ngFor="let img of popupImages"
            class="img-section"
          />
          <div *ngIf="isDebris" class="img-overlay-text-top">
            {{ languageIndex === 0 ? 'top' : 'arriba' }}
          </div>
          <div *ngIf="isDebris" class="img-overlay-text-bottom">
            {{ languageIndex === 0 ? 'bottom' : 'abajo' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
